import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";

import {
  DAMAGES_PICKER,
  ISSUES,
  PENALIZATIONS_PICKER,
  RESERVE_REDUCTIONS_PICKER,
  TASKS,
  USERS_PICKER,
} from "@/modules/Administration/routesInterface";

const menu = {
  code: MODULE.ADMINISTRATION.CODE,
  name: "administration",
  label: "common.administration",
  link: ISSUES,
  children: [],
  createChildren: []
};

const submenus = [
  {
    code: MODULE.ADMINISTRATION.DASHBOARD,
    icon: "dashboard",
    label: "common.dashboard",
    link: TASKS,
    name: "home",
    tooltip: "common.home"
  },
  {
    code: MODULE.ADMINISTRATION.USERS,
    icon: "user-validation",
    label: "common.users",
    link: USERS_PICKER,
    name: "users",
    tooltip: "common.users",
    value: null
  },
  {
    code: MODULE.ADMINISTRATION.DAMAGES,
    icon: "wrench-1",
    label: "common.damages",
    link: DAMAGES_PICKER,
    name: "damages",
    tooltip: "common.damages",
    value: null
  },
  {
    code: MODULE.ADMINISTRATION.PENALIZATIONS,
    icon: "gavel",
    label: "common.penalizations",
    link: PENALIZATIONS_PICKER,
    name: "penalizations",
    tooltip: "common.penalizations",
    value: null
  },
  {
    code: MODULE.ADMINISTRATION.RESERVE_REDUCTIONS,
    icon: "booking-task",
    label: "common.reserveReductions",
    link: RESERVE_REDUCTIONS_PICKER,
    name: "reserveReductions",
    tooltip: "common.reserveReductions",
    value: null
  },
  {
    code: MODULE.ADMINISTRATION.INCIDENCES,
    icon: "document-error",
    label: "common.helpDesk",
    link: ISSUES,
    name: "issues",
    tooltip: "common.issues",
    value: null
  },
];

function getMenu(submodules) {
  menu.children = [];
  submodules.forEach((submodule) => {
    const submenuAux = submenus.find((submenu) => submenu.code === submodule.code);
    if (submenuAux && (submodule.r || submodule.w)) {
      menu.children.push(submenuAux);
    }
  });
  return menu;
}

export default { getMenu };